import React, { Component, Fragment } from 'react';
import { CSVReader } from 'react-papaparse';
import Button from '@material-ui/core/Button';


export default function CSVReader1(props){
  const buttonRef = React.createRef();



  function handleOpenDialog(e){
    // Note that the ref is set async, so it might be null at some point
    if (buttonRef.current) {
      buttonRef.current.open(e);
    }
  };
  

  function handleOnFileLoad(data, fileInfo){
    props.csvLoaded(data);
    console.log('FILE INFO ...... ', fileInfo, fileInfo.name);
    if(props.setFileName!=undefined){props.setFileName(fileInfo.name);}

    console.log('---------------------------');
    console.log(data);
    console.log('---------------------------');
  };

  function handleOnError(err, file, inputElem, reason){
    console.log('---------------------------');
    console.log(err);
    console.log('---------------------------');
  };

  function handleOnRemoveFile(data){
    console.log('---------------------------');
    console.log(data);
    console.log('---------------------------');
  };

  function handleRemoveFile(e){
    // Note that the ref is set async, so it might be null at some point
    if (buttonRef.current) {
      buttonRef.current.removeFile(e);
    }
  };

    return (
      <Fragment>
        <CSVReader
          ref={buttonRef}
          onFileLoad={handleOnFileLoad}
          onError={handleOnError}
          noClick
          noDrag
          onRemoveFile={handleOnRemoveFile}
        >
          {({ file }) => (
            <Fragment>
              <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'20px'}}><Button component='label' for='csv_upload' color='secondary' variant='contained' onClick={handleOpenDialog}>Select csv file</Button></div>
               {(props.show_file_name==true)?<div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'10px'}}>
                  <div
                    style={{
                      borderWidth: 1,
                      borderStyle: 'solid',
                      borderColor: '#ccc',
                      height: 30,
                      lineHeight: 2.5,
                      marginTop: 5,
                      marginBottom: 5,
                      paddingLeft: 13,
                      width: '60%',
                    }}
                  >
                    {file && file.name}
                  </div>
                </div>:null}
            </Fragment>
          )}
        </CSVReader>
      </Fragment>
    );
}
